import { useEffect, type FC } from "react";
import { useAppSearch } from "../../app/appSearchContext.js";
import { NavigationSearchItem } from "./navigationSearchItem.js";
import type { SearchContextType } from "./searchContexts.js";

export interface NavigationSearchContainerProps {
  context: SearchContextType;
}

/**
 * Nav search trigger. Registers its section's search context and opens the
 * shared modal (owned by `AppSearchProvider`), so the two nav copies never open
 * separate modals.
 */
export const NavigationSearchContainer: FC<NavigationSearchContainerProps> = ({
  context,
}) => {
  const { isSearchActive, openSearch, registerSearchContext } = useAppSearch();

  useEffect(
    () => registerSearchContext(context),
    [context, registerSearchContext],
  );

  return (
    <NavigationSearchItem isActive={isSearchActive} onPress={openSearch} />
  );
};
